import { Component } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { HomeTile } from './../../models/hometiles/hometiles.model';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-hometile-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html', // TODO: tile list template
})
export class HomeTileListComponent extends ListBase<HomeTile> {

  public url = 'home-tiles';
  public routePrefix = 'hometiles';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
